/** Debounce scheduler rebuilds, but only for an active transport. */
export function createPlaybackRescheduler({ isPlaying, reschedule, delay = 50 }) {
  let timer = null;
  return {
    schedule() {
      if (!isPlaying()) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        if (isPlaying()) reschedule();
      }, delay);
    },
    cancel() {
      if (timer) clearTimeout(timer);
      timer = null;
    },
  };
}

/** What determines the playback schedule: which clips exist and where, not mixer settings. */
export function arrangementSignature(tracks) {
  return JSON.stringify((tracks || []).map((track) => [
    track.id,
    (track.clips || []).map((clip) => [clip.id, clip.loop_id, clip.start_bar, clip.bars,
      clip.sourceBpm, clip.offset ?? null, clip.trim_start ?? null, clip.trim_end ?? null,
      clip.isKnockEngine ? [clip.knockPattern || [], clip.knockSoundType, clip.knockOscType, clip.knockFilterFreq, clip.knockDetune, clip.knockVolume] : null,
      clip.isPattern ? [clip.patternType, clip.pattern] : null, clip.pitch ?? 0, clip.stretch ?? true, clip.speed ?? 1]),
  ]));
}
